module.exports = __webpack_public_path__ + "img/sg-header.ae680f47.png";